<template>
  <div>
    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-wallet </v-icon>
        <span class="px-2">{{$t('driver_wallet_settings')}}</span>
      </v-card-title>
      <v-card-text>
        <vue-element-loading :active="isLoading" />
        <v-form ref="form" v-if="settings" v-model="valid" lazy-validation class="my-2">
          <div class="text-caption text--secondary mb-4">
            {{$t('driver_wallet_settings_desc')}}
          </div>
          <v-row>
            <v-col cols="12" md="6" class="my-2">
              <v-text-field
                v-model="settings.general_driver_earning_percentage"
                type="number"
                outlined
                dense
                min="0"
                max="100"
                step="0.01"
                :label="$t('general_driver_earning_percentage')"
                :placeholder="$t('enter_general_percentage')"
                persistent-hint
                required
                :rules="earningPercentageRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="my-2">
              <v-text-field
                v-model="settings.with_vehicle_driver_earning_percentage"
                type="number"
                outlined
                dense
                min="0"
                max="100"
                step="0.01"
                :label="$t('with_vehicle_driver_earning_percentage')"
                :placeholder="$t('enter_with_vehicle_percentage')"
                persistent-hint
                required
                :rules="earningPercentageRules"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" color="primary" @click="saveSettings">
          {{$t('save')}}
          <v-icon right dark> mdi-content-save </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import VueElementLoading from "vue-element-loading";

export default {
  components: {
    VueElementLoading,
  },
  data() {
    return {
      isLoading: false,
      settings: null,
      valid: true,
      earningPercentageRules: [
        (v) => (v !== null && v !== undefined && v !== '') || this.$t("required"),
        (v) => !isNaN(parseFloat(v)) || this.$t("must_be_numeric"),
        (v) => (parseFloat(v) >= 0 && parseFloat(v) <= 100) || this.$t("must_be_0_to_100")
      ],
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    saveSettings() {
      this.isLoading = true;
      axios
        .post("/settings/update", this.settings)
        .then((response) => {
          this.$notify({
            title: "Success",
            text: this.$t("driver_wallet_settings_saved"),
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            text: this.$t("error_updating_settings"),
            type: "error",
          });
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    loadSettings() {
      this.isLoading = true;
      axios
        .get(`/settings/all`)
        .then((response) => {
          this.settings = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            text: this.$t("error_retrieving_settings"),
            type: "error",
          });
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
